import React from 'react'

import { useLazyLoadQuery, graphql } from 'react-relay'

import { GuildCard } from '@newComponents/Guild/GuildCard'

import { GuildCardEmbedQuery } from './__generated__/GuildCardEmbedQuery.graphql'

export function GuildCardEmbed({
  slug,
  expand = true,
}: {
  slug: string
  expand?: boolean
}) {
  const data = useLazyLoadQuery<GuildCardEmbedQuery>(
    graphql`
      query GuildCardEmbedQuery($slug: String!) {
        nodeBySlugId(id: $slug) {
          __typename

          ... on Guild {
            ...GuildCardNew_guild
          }
        }
      }
    `,
    { slug }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    console.error(`GuildCardEmbed: Could not find Guild with ID "${slug}"`)

    return null
  }

  return <GuildCard guild={data.nodeBySlugId} expand={expand} />
}

export default GuildCardEmbed
